import * as THREE from 'three';

// Size = 2 will create a quad vertices in the -1:1 range good to cover canvas in screen space
// Size = 1 will create a quad vertices in the -0.5:0.5 range good for drawing rects in screen space
export default function screenQuad(mat: THREE.Material, order = 100, size = 2) {
  const mesh = new THREE.Mesh(new THREE.PlaneGeometry(size, size, 1), mat);
  mesh.renderOrder = order; // Usually set it last for rendering
  mesh.frustumCulled = false; // Easily gets culled from frustum tests, disable it
  return mesh;
}
